export default __webpack_public_path__ + "static/media/culture-is-near.e5fae8f1.png";